import styled from 'styled-components'

export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`

export const SectionTitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.default};
  min-height: 37px;
`

export const ActionsTitleContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp4};
`

export const SectionInfoContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
`

export const InfoColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp4};
`

export const CarrierLogo = styled.img`
  height: ${props => props.theme.size.S};
  width: ${props => props.theme.size.S};
  object-fit: contain;
  aspect-ratio: 1/1;
`

export const PickupPointInfo = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp4};
`
